import { css } from '@emotion/react';
import { FC } from 'react';

export type StepProps = {
  index: number;
  label: string;
  activeStep: number;
  stepSize: number;
};

const applyMainStyles = (passed: boolean, active: boolean) => (theme) => {
  const defaultStyle = css(theme.stepper.step);

  const styles = [defaultStyle];
  if (!passed && !active) {
    styles.push(css(theme.stepper.step.futureStep));
  }

  return css(...styles);
};

export const Step: FC<StepProps> = ({
  index,
  activeStep,
  label,
  stepSize,
}: StepProps) => {
  const passed = index < activeStep;
  const active = index === activeStep;

  return (
    <span
      css={applyMainStyles(passed, active)}
      style={{ maxWidth: `${stepSize}%`, width: `${stepSize}%` }}
    >
      {label}
    </span>
  );
};
